export default class BackgroundImage {

    constructor({ element, index }) {
        this.element = element;
        // this._loaded = element.classList.contains('active');
        this._loaded = false;
        this._index = index;

        this.bgLayer = element.querySelector('.bg-layer');
        this.src = this.bgLayer.dataset.src;

        const overlay = element.querySelector('.custom-image-overlay');
        const bgColour = overlay.dataset.bg;
        overlay.classList.add(`bg-${bgColour}`, 'show');
    }

    load(callback) {
        const img = new Image();

        console.log("Loading", this.src);

        img.addEventListener('load', () => {
            this.bgLayer.style.backgroundImage = `url(${this.src})`;
            this.bgLayer.classList.add('show');
            callback(this);

            this._loaded = true;
        });

        img.src = this.src;
    }

    get loaded() {
        return this._loaded;
    }

    get index() {
        return this._index;
    }

    set active(state) {
        const f = state ? 'add' : 'remove';
        this.element.classList[f]('active')
    }
}